import axios from 'axios';
import { apiBaseUrl } from 'App';
import { getCsrfToken } from './csrfFunctions';
import { loadSessionData, LoginCallbacks, LoginResponse } from './loadSessionData';

interface TwoFactorVerifyResult {
    status: 'success' | 'error';
    redirect?: 'trial-wizard/1' | 'trial-homepage' | 'dashboard' | 'admin-dashboard' | 'settings/admin/environments' | 'setup-2fa';
    error?: string;
}

interface TwoFactorVerifyParams {
    code: string;
    navigator_language: string;
    navigator_locale: string;
    navigator_timezone: string | null;
    utc_datetime: string;
    callbacks: LoginCallbacks;
}

// Verify the two factor code and complete the login
export const verifyTwoFactorCode = async ({
    code,
    navigator_language,
    navigator_locale,
    navigator_timezone,
    utc_datetime,
    callbacks
}: TwoFactorVerifyParams): Promise<TwoFactorVerifyResult> => {
    // Get the csrf token
    const csrfToken = getCsrfToken();

    try {
        // Send the two factor verification request
        const response = await axios.post<LoginResponse>(
            `${apiBaseUrl}/post_twofactorverification/`,
            {
                'twofactor-code': code,
                navigator_language,
                navigator_locale,
                navigator_timezone,
                utc_datetime
            },
            {
                withCredentials: true,
                headers: {
                    'X-CSRFToken': csrfToken
                }
            }
        );

        // Load the session data
        loadSessionData({
            responseData: response.data,
            callbacks
        });

        // Return success
        return {
            status: 'success',
            redirect: response.data.environment_data.redirect_to
        };
    } catch (error: any) {
        // Configure the error message
        const errorMessage = error.response?.data?.general || error.message || 'Error while verifying the code';

        // Return the error
        return {
            status: 'error',
            error: errorMessage
        }
    }
}
